module.exports = __webpack_public_path__ + "img/moon-75.1d944c58.svg";